import { Injectable }           from '@angular/core';
import { Http, Response }       from '@angular/http';
import { Observable }           from 'rxjs/Observable';
import { FileUploader }         from 'ng2-file-upload';
import { ConfigService }        from '../configuracion/config.service';
import { RequestBaseService }   from '../request-base/request-base.service';
import { JwtHttp, AuthService } from 'ng2-ui-auth';

import 'rxjs/add/operator/map';

@Injectable()
export class MaquinaService extends RequestBaseService {
  constructor(
    protected http: JwtHttp,
    protected auth: AuthService,
    protected config: ConfigService
  ) {
    super(http, auth);
    this.ApiUrl = [config.getApiUrl(), 'maquina'].join('/');
  }

  public getTrimestre(fecha?: Date): number {
    let fechaTrim = fecha || new Date();
    let mesTrim = fechaTrim.getMonth();
    let meses = [1, 1, 1, 2, 2, 2, 3, 3, 3, 4, 4, 4];

    return meses[mesTrim];
  }
 
  public save(model: any): Observable<any> {
    let file: FileUploader = model.imagen;

    model.imagen = 'logo-inger.png';

    return new Observable(observer => {
      super.save(model)
        .subscribe(
          data => {
            if(file.queue.length > 0) {
              file.authToken      = this.auth.getToken();
              file.options.url    = [this.ApiUrl, data.id, 'upload'].join('/');
              file.queue[0].url   = [this.ApiUrl, data.id, 'upload'].join('/');

              file.queue[0].upload();

              file.queue[0]._xhr.onreadystatechange = function(e) {
                if(file.queue[0]._xhr.readyState == 4) {
                  data.imagen = [data.id, 'jpg'].join('.');

                  observer.next(data);
                }
              }               
            } else {
              observer.next(data);
            }
          },
          error => console.log(error)
        )
    });
  }
 
  public update(id, model: any): Observable<any> {
    let file: FileUploader = model.imagen;

    delete model.imagen;

    return new Observable(observer => {
      super.update(id, model)
        .subscribe(
          data => {
            if(file.queue.length > 0) {
              file.authToken      = this.auth.getToken();
              file.options.url    = [this.ApiUrl, data.id, 'upload'].join('/');
              file.queue[0].url   = [this.ApiUrl, data.id, 'upload'].join('/');

              file.queue[0].upload();

              file.queue[0]._xhr.onreadystatechange = function(e) {
                if(file.queue[0]._xhr.readyState == 4) {
                  data.imagen = [data.id, 'jpg'].join('.');

                  observer.next(data);
                }
              }               
            } else {
              observer.next(data);
            }
          },
          error => console.log(error)
        )
    });
  }

  public getProgramacion(maquina_id) {
    return this.http.get(
      [
        this.ApiUrl,
        maquina_id,
        'programacion'
      ].join('/')
    )
    .map(res => res.json());
  }

  public getMaquinasXUsuario(usuario_id) {
    return this.http.get(
      [
        this.config.getApiUrl(),
        'usuario',
        usuario_id,
        'maquina'
      ].join('/')
    )
    .map(res => res.json());
  }

  public getUsuariosXMaquina(maquina_id) {
    return this.http
      .get([
        this.ApiUrl,
        maquina_id,
        'usuarios'
      ].join('/'))
      .map(res => res.json())
  }

  public getProgramacionByMaquina(maquina_id, year) {
    return this.http
      .get([
        this.ApiUrl,
        maquina_id,
        'programacion',
        year
      ].join('/'))
      .map(res => res.json());
  }

  public updateProgramacionMaquina(maquina_id, programacion_id, model): Observable<any> {
    this.validate();

    return this.http
      .put([this.config.getApiUrl(), 'programacion-anual', programacion_id].join('/'), {data: model})
      .map(res => res.json());    
  }

  public calculaSemana(year, week): any {
    // obtenemos el primer dia del año
    var primerdia = new Date(year, 0, 1);
    
    // obtenemos la corrección necesaria
    var correccion = 6 - primerdia.getDay();
    
    // validación para la semana
    if (week * 7 + correccion > 365) { alert("El valor para semana no es válido"); return false; }
    
    // obtenemos el lunes y domingo de la semana especificada
    var primer = new Date(year, 0, (week - 1) * 7 + 3 + correccion);
    var ultimo = new Date(year, 0, (week - 1) * 7 + 9 + correccion);

    // mostramos el resultado
    return {
      primer: primer,
      ultimo: ultimo
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/services/maquina/maquina.service.ts